import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import AccessTokenSessionService from "../../../../../../../../services/Security/accessTokenSessionService";
import { handleTokenRefresh } from "../../../../../../../../services/Security/applyAppTokenRefreshInterceptor";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";
import { TOKEN_KEY } from "../../../../../../../../services/session/reducer";
import { selectUser } from "../../../../../../../../services/users/selectors";
import { getApiURL } from "../../../../../../../../utils/envutil";

interface Props {
	show: boolean;
	onHide: () => void;
	redirectUrl?: string;
}

const PaymentModal = ({ show, onHide, redirectUrl }: Props) => {
	const organization = useSelector(selectOrganization);
	const user = useSelector(selectUser);

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		await handleTokenRefresh();
		const iframe = document.createElement("iframe");
		iframe.id = "payment-iframe";
		iframe.src = "/card.html";
		iframe.style.width = "100%";

		const iframeContainer = document.getElementById("payment-iframe-container");

		if (iframeContainer) {
			iframeContainer.appendChild(iframe);
			iframe.onload = () => {
				const message = JSON.stringify({
					organizationId: organization.id,
					token: AccessTokenSessionService.get() || localStorage.getItem(TOKEN_KEY),
					baseUrl: getApiURL(),
					redirectUrl,
					autopayCardsDomain: user.autopay_url,
					autopayServiceId: user.autopay_service_id,
				});
				iframe.contentWindow?.postMessage(message);
			};
		}
	};

	return (
		<Modal show={show} onHide={onHide} className="payment-modal">
			<Modal.Header closeButton />
			<Modal.Body>
				<div id="payment-iframe-container"></div>
			</Modal.Body>
		</Modal>
	);
};

export default PaymentModal;
